<template>
  <div>
    <h4>Basic Setting</h4>
    <el-card>
      <el-form-item label="Date Range">
        <el-date-picker
          v-model="dateRangePicker"
          type="daterange"
          range-separator="-"
          start-placeholder="From"
          end-placeholder="To"
          format="dd MMM yyyy"
          value-format="yyyy-MM-dd"
          size="mini"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-if="showWarehouseChk" label="Warehouse">
        <el-checkbox v-model="checkWarehouseAll">ALL</el-checkbox>
        <el-checkbox-group v-show="!checkWarehouseAll" v-model="checkedWarehouses" size="mini">
          <el-checkbox-button
            v-for="item in warehouses"
            :label="item"
            :key="item.value"
          >{{item.label}}</el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item v-if="showWarehouseRadio" label="Warehouse ">
        <el-checkbox v-model="checkWarehouseAll">ALL (Single selection)</el-checkbox>
        <el-radio-group v-show="!checkWarehouseAll" v-model="checkedWarehouses" size="mini">
          <el-radio-button
            v-for="item in warehouses"
            :label="item"
            :key="item.value"
          >{{item.label}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <div v-if="showOutInWarehouse">
        <el-form-item label="Out Warehouse">
          <el-checkbox v-model="checkOutWarehouseAll">ALL</el-checkbox>
          <el-checkbox-group v-show="!checkOutWarehouseAll" v-model="checkedOutWarehouses" size="mini">
            <el-checkbox-button
              v-for="item in warehouses"
              :label="item"
              :key="item.value"
            >{{item.label}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="In Warehouse">
          <el-checkbox v-model="checkInWarehouseAll">ALL</el-checkbox>
          <el-checkbox-group v-show="!checkInWarehouseAll" v-model="checkedInWarehouses" size="mini">
            <el-checkbox-button
              v-for="item in warehouses"
              :label="item"
              :key="item.value"
            >{{item.label}}</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ReportBasicSettingInv',
  created () {
    this.setDateType('date')
  },
  props: {
    showOutInWarehouse: {
      type: Boolean,
      default: false
    },
    showWarehouseChk: {
      type: Boolean,
      default: true
    },
    showWarehouseRadio: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('report', [
      'type',
      'dateType',
      'dateRange',
      'selectedWh',
      'warehouseAll',
      'selectedOutWh',
      'outWarehouseAll',
      'selectedInWh',
      'inWarehouseAll'
    ]),
    ...mapState(['warehouses']),
    dateRangePicker: {
      get () {
        return this.dateRange
      },
      set (val) {
        this.setDateRange(val)
      }
    },
    checkWarehouseAll: {
      get () {
        return this.warehouseAll
      },
      set (val) {
        this.setWarehoueAll(val)
        if (!val) {
          this.setWarehouses([])
        }
      }
    },
    checkedWarehouses: {
      get () {
        return this.selectedWh
      },
      set (val) {
        this.setWarehouses(val)
        if (this.selectedWh.length === this.warehouses.length) {
          this.setWarehoueAll(true)
        }
      }
    },
    checkOutWarehouseAll: {
      get () {
        return this.outWarehouseAll
      },
      set (val) {
        this.setOutWarehoueAll(val)
        if (!val) {
          this.setOutWarehouses([])
        }
      }
    },
    checkedOutWarehouses: {
      get () {
        return this.selectedOutWh
      },
      set (val) {
        this.setOutWarehouses(val)
        if (this.selectedOutWh.length === this.warehouses.length) {
          this.setOutWarehoueAll(true)
        }
      }
    },
    checkInWarehouseAll: {
      get () {
        return this.inWarehouseAll
      },
      set (val) {
        this.setInWarehoueAll(val)
        if (!val) {
          this.setInWarehouses([])
        }
      }
    },
    checkedInWarehouses: {
      get () {
        return this.selectedInWh
      },
      set (val) {
        this.setInWarehouses(val)
        if (this.selectedInWh.length === this.warehouses.length) {
          this.setInWarehoueAll(true)
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setDateType: 'report/setDateType',
      setDateRange: 'report/setDateRange',
      setWarehouses: 'report/setWarehouses',
      setWarehoueAll: 'report/setWarehoueAll',
      setOutWarehouses: 'report/setOutWarehouses',
      setOutWarehoueAll: 'report/setOutWarehoueAll',
      setInWarehouses: 'report/setInWarehouses',
      setInWarehoueAll: 'report/setInWarehoueAll'
    })
  }
}
</script>

<style lang="scss" scoped>
.note {
  margin-left: 18px;
  font-size: 12px;
  color: #9b9b9b
}
</style>
